<template>
    <v-layout column class="messenger-group">
        <status-bar :action="createAction"></status-bar>
        <v-layout column class="messenger-group__create relative-position">
            <div v-if="createGroupInProgress" class="disabled-overlay"></div>
            <v-flex class="messenger-group__create-title" pa-3 v-if="isNewGroup">
                {{iamConstants.CREATE_NEW_YPO_MESSENGER_GROUP}}
            </v-flex>
            <v-flex class="messenger-group__edit-title" v-if="!isNewGroup">
                <v-layout row v-if="!renameGroupToggled">
                    <v-flex pa-3 class="messenger-group__name">
                        {{groupChat.name}}
                    </v-flex>
                    <v-flex>
                        <v-card-actions class="text-right messenger-group__menu-actions">
                            <v-btn flat @click="messageGroup"
                                   color="ypo_cta"
                                   data-qe-id="message-group_btn--desktop"
                                   class="messenger-group__message-btn chat--desktop">
                                <v-icon color="ypo_cta" class="fas fa-comments" size="20"></v-icon>
                                <span class="messenger-group__message-label">
                                        {{ iamConstants.MESSAGE_GROUP}}
                                    </span>
                            </v-btn>
                            <v-btn flat icon
                                   color="ypo_cta"
                                   class="chat--mobile"
                                   @click="messageGroup"
                                   data-qe-id="message-group_btn--mobile">
                                <v-icon color="ypo_cta" class="fas fa-comments" size="18"></v-icon>
                            </v-btn>
                            <conversation-panel-menu
                                    :conversation="conversation"
                                    :on-rename-action="handleRename"
                                    :on-deleted="onDeleted">
                            </conversation-panel-menu>
                        </v-card-actions>
                    </v-flex>
                </v-layout>
                <v-layout v-else pl-2 pr-2>
                    <v-flex xs9>
                        <v-text-field v-model="groupChat.name"
                                      autofocus
                                      :maxlength="iamConstants.GROUP_NAME_MAX"
                                      hide-details
                                      @click="searchMemberActive = false"
                                      data-qe-id="update_group_chat_name"
                                      class="messenger-group__input-box"
                                      :placeholder="iamConstants.NEW_GROUP_CHAT_PLACEHOLDER">
                        </v-text-field>
                    </v-flex>
                    <v-flex class="text-right">
                        <v-card-actions class="chat--desktop">
                            <v-btn flat color="ypo_blue" class="bold-font"
                                   data-qe-id="chat-desktop_group-rename_cancel_btn"
                                   @click="renameGroupToggled = false">
                                {{appCommonConstants.CANCEL}}
                            </v-btn>
                            <v-btn dark class="primary bold-font" @click="renameGroup"
                                   data-qe-id="chat-desktop_group-rename_save_btn">
                                {{appCommonConstants.SAVE}}
                            </v-btn>
                        </v-card-actions>
                        <v-card-actions class="chat--mobile">
                            <v-btn flat icon color="ypo_blue" class="bold-font"
                                   data-qe-id="chat-mobile_group-rename_cancel_btn"
                                   @click="renameGroupToggled = false">
                                <v-icon>highlight_off</v-icon>
                            </v-btn>
                            <v-btn flat icon color="ypo_blue" class="bold-font"
                                   data-qe-id="chat-mobile_group-rename_save_btn"
                                   @click="renameGroup">
                                <v-icon>check_circle_outline</v-icon>
                            </v-btn>
                        </v-card-actions>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex class="messenger-group__new-group" pt-1 pl-3 pr-3 pb-1 v-if="isNewGroup">
                <v-layout row>
                    <v-flex xs9>
                        <v-text-field v-model="groupChat.name"
                                      autofocus
                                      :maxlength="iamConstants.GROUP_NAME_MAX"
                                      hide-details
                                      @click="searchMemberActive = false"
                                      data-qe-id="new_group_chat_name"
                                      class="messenger-group__input-box"
                                      :placeholder="iamConstants.NEW_GROUP_CHAT_PLACEHOLDER">
                        </v-text-field>
                    </v-flex>
                    <v-flex class="text-right">
                        <v-btn :dark="!!canCreate" class="primary bold-font"
                               data-qe-id="chat_create-new-group_btn"
                               @click="createNewChatGroup"
                               :disabled="!canCreate">
                            {{appCommonConstants.CREATE}}
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex class="messenger-group__participants" v-if="!!groupChat.name">
                <v-layout row pt-2 pr-2 pl-3>
                    <v-flex>
                        <v-layout>
                            <v-flex :class="[
                                        'messenger-group__participants-count',
                                        canAddMoreParticipants ? '' : 'messenger-group__participants-count--max'
                                    ]">
                                {{participantsCount}}
                            </v-flex>
                            <v-flex class="messenger-group__participants-remaining">
                                <div class="messenger-group__participants-remaining--count">
                                    /{{iamConstants.MAX_PARTICIPANTS}}
                                </div>
                                <div class="messenger-group__participants-remaining--label">
                                    {{iamConstants.PARTICIPANTS}}
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex class="text-right" v-if="canAddMoreParticipants">
                        <v-btn flat color="ypo_cta"
                               :class="['messenger-group__participants-add', searchMemberActive ? 'opacity-half' : '']"
                               @click="activateSearchMember"
                               data-qe-id="messenger-group__participants-add__btn">
                            <v-icon size="20" class="messenger-group__participants-add-icon">group_add</v-icon>
                            <span class="messenger-group__participants-add-label">
                                {{iamConstants.ADD_PARTICIPANTS_TO_GROUP}}
                            </span>
                        </v-btn>
                    </v-flex>
                </v-layout>
                <v-flex pl-3 pr-3 v-if="searchMemberActive && canAddMoreParticipants" class="messenger-group__search">
                    <v-text-field
                            :outline="false"
                            hide-details
                            class="messenger-group__input-box"
                            :autofocus="searchMemberActive"
                            data-qe-id="messenger-group_search_member_input"
                            @keyup="searchMember(memberSearchText)"
                            browser-autocomplete="new-password"
                            :placeholder="iamConstants.SEARCH_PLACEHOLDER_IN_GROUP"
                            v-model="memberSearchText">
                    </v-text-field>
                    <v-layout column v-if="memberSearchText"
                              class="relative-position messenger-group__search-result">
                        <status-overlay
                                :action="typeAheadAction"
                                content-height="150px"></status-overlay>
                        <v-layout column v-if="memberSearchResult && memberSearchResult.length"
                                  class="messenger-group__search-result--list inner-scrollbar">
                            <v-flex v-for="member in memberSearchResult"
                                    pa-1
                                    class="messenger-group__search-item"
                                    :key="member.id">
                                <v-card>
                                    <v-layout row pa-2>
                                        <v-flex pa-2>
                                            <v-avatar size="40" class="messenger-avatar">
                                                <img :src="member.profileImageUrl"
                                                     :key="member.profileImageUrl"
                                                     :onerror="imageErrorFallback(member.fallbackProfileImageUrl)">
                                            </v-avatar>
                                        </v-flex>
                                        <v-flex pa-2 xs8 class="member-result__desc text-overflow-ellipse">
                                            <div class="member-result__desc-name text-overflow-ellipse">
                                                {{memberName(member)}}
                                            </div>
                                            <div class="member-result__desc-chapter text-overflow-ellipse">
                                                {{memberChapter(member)}}
                                            </div>
                                        </v-flex>
                                        <v-flex pt-2 pb-2 pl-2 pr-0 class="member-result__action">
                                            <v-btn color="primary"
                                                   class="bold-font chat--desktop"
                                                   small
                                                   flat
                                                   outline
                                                   data-qe-id="messenger_desktop_add-to-participants_btn"
                                                   @click="addToParticipants(member)">{{appCommonConstants.ADD}}
                                            </v-btn>
                                            <v-btn color="primary"
                                                   class="bold-font chat--mobile"
                                                   icon
                                                   flat
                                                   data-qe-id="messenger_mobile_add-to-participants_btn"
                                                   @click="addToParticipants(member)">
                                                <v-icon>add_circle_outline</v-icon>
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-card>
                            </v-flex>
                        </v-layout>
                        <v-flex pt-1 pb-1 pr-3 v-if="memberSearchResult && memberSearchResult.length"
                                class="messenger-group__search-result--done">
                            <v-btn color="primary"
                                   small
                                   data-qe-id="done_adding_participants_btn"
                                   @click="doneAddingParticipants">
                                {{appCommonConstants.DONE}}
                            </v-btn>
                        </v-flex>
                        <v-flex v-if="memberSearchResult && memberSearchResult.length === 0"
                                class="messenger-group__search-no-result">
                            {{iamConstants.NO_RESULTS}}
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-flex>
            <v-flex pa-2
                    class="messenger-group__active-participants inner-scrollbar">
                <v-layout v-if="groupParticipants && groupParticipants.length" row wrap>
                    <v-flex xs12 md6 pa-1
                            v-for="(participant, index) in groupParticipants"
                            :key="index">
                        <v-card>
                            <v-layout row pt-2 pb-2 pr-1 pl-2>
                                <v-flex pa-2>
                                    <v-avatar size="40" class="messenger-avatar">
                                        <img :src="participant.profileImageUrl"
                                             :key="participant.profileImageUrl"
                                             :onerror="imageErrorFallback(participant.fallbackProfileImageUrl)">
                                    </v-avatar>
                                </v-flex>
                                <v-flex pa-2 xs8 class="member-result__desc text-overflow-ellipse">
                                    <div class="member-result__desc-name text-overflow-ellipse">
                                        {{memberName(participant)}}
                                    </div>
                                    <div class="member-result__desc-chapter text-overflow-ellipse">
                                        {{memberChapter(participant)}}
                                    </div>
                                </v-flex>
                                <v-flex pt-2 pb-2 pl-2 pr-0 class="member-result__action">
                                    <v-btn color="primary"
                                           class="bold-font"
                                           icon
                                           flat
                                           data-qe-id="messenger_remove-participants_btn"
                                           @click="removeParticipant(participant)">
                                        <v-icon>remove_circle_outline</v-icon>
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-layout>
</template>

<script>
    import { appCommonConstants } from "../../appCommon.constants";
    import { iamConstants, newGroupChatObject } from '../iam.constant';
    import { imageErrorFallback } from "../../../common/utils/utils";
    import { conversationTitle, isValidConversationId } from '../iam.utils';
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import { storeAction } from '../../../store/storeActions.constant';
    import { storeGetters } from '../../../store/storeGetters.constant';
    import { storeMutation } from '../../../store/storeMutations.constant';
    import StatusOverlay from "../../StatusOverlay/StatusOverlay";
    import ConversationPanelMenu from "./ConversationPanelMenu";
    import StatusBar from "../../StatusBar/StatusBar";

    export default {
        name: 'MessengerGroup',
        components: {
            StatusBar,
            ConversationPanelMenu,
            StatusOverlay,
        },
        props: {
            conversation: {
                type: Object,
                required: true,
            },
            onCreated: {
                type: Function,
                required: true,
            },
            onDeleted: {
                type: Function,
                required: false,
            },
            onMessageGroup: {
                type: Function,
                required: false,
            },
            closeChatAction: {
                type: Function,
            },
        },
        created() {
            this.groupChat = { ...this.conversation };
            const p = Object.keys(this.conversation.participants);
            this.showParticipantsAutocomplete = !p.length;
        },
        data() {
            return {
                iamConstants,
                appCommonConstants,
                groupChat: null,
                currentDialog: null,
                draftParticipantsList: [],
                showParticipantsAutocomplete: false,
                typeAheadSearch: '',
                loadingTypeAhead: false,
                timeoutForTypeAhead: null,
                memberSearchResult: null,
                memberSearchText: '',
                searchMemberActive: false,
                renameGroupToggled: false,
                createGroupInProgress: false,
            };
        },
        computed: {
            ...mapState('actionState', ['actions']),
            ...mapGetters('messenger', {
                messengerUsername: storeGetters.messengerUsername,
            }),
            ...mapGetters({
                currentUserId: `memberProfile/${storeGetters.currentUserId}`,
            }),
            createAction() {
                return this.actions[storeAction.createChatGroup];
            },
            participantsCount() {
                return this.groupParticipants.length;
            },
            canCreate() {
                return Object.keys(this.groupChat.participants).length && this.groupChat.name;
            },
            title() {
                return conversationTitle(Object.keys(this.conversation.participants)
                    .filter(k => k !== this.messengerUsername)
                    .map(k => this.conversation.participants[k]), this.conversation.id);
            },
            typeAheadAction() {
                return this.actions[storeAction.initiatePeopleSearch];
            },
            groupParticipants() {
                const participantsList = [];
                const participants = Object.keys(this.groupChat.participants || {});
                if (participants.length) {
                    participants.forEach((id) => {
                        if (id !== this.currentUserId) {
                            participantsList.push(this.groupChat.participants[id]);
                        }
                    });
                }
                return participantsList;
            },
            canAddMoreParticipants() {
                return this.groupParticipants.length < iamConstants.MAX_PARTICIPANTS;
            },
            isNewGroup() {
                return this.groupChat.id === iamConstants.DRAFT_CHAT_ID;
            },
        },
        methods: {
            ...mapMutations('memberDirectory', {
                setMemberDirectorySearchText: storeMutation.setMemberDirectorySearchText,
            }),
            ...mapActions('messenger', {
                createChatGroup: storeAction.createChatGroup,
                inviteToConversation: storeAction.inviteToConversation,
                removeFromConversation: storeAction.removeFromConversation,
                deleteConversation: storeAction.deleteConversation,
                renameConversation: storeAction.renameConversation,
            }),
            ...mapActions('memberDirectory', {
                initiatePeopleSearch: storeAction.initiatePeopleSearch,
            }),
            imageErrorFallback,
            createNewChatGroup() {
                this.createGroupInProgress = true;
                this.searchMemberActive = false;
                this.createChatGroup(this.groupChat).then((resp) => {
                    this.createGroupInProgress = false;
                    this.onCreated(resp.room_id);
                    this.groupChat = newGroupChatObject();
                });
            },
            activateSearchMember() {
                this.searchMemberActive = !this.searchMemberActive;
            },
            messageGroup() {
                this.onMessageGroup(this.groupChat);
            },
            handleRename() {
                this.renameGroupToggled = true;
            },
            renameGroup() {
                this.renameConversation({
                    roomId: this.groupChat.id,
                    roomName: this.groupChat.name,
                }).then(() => { this.renameGroupToggled = false; });
            },
            addToParticipants(member) {
                if (this.canAddMoreParticipants) {
                    if (!this.isNewGroup) {
                        const inviteData = {
                            roomId: this.groupChat.id,
                            memberId: member.id,
                        };
                        this.inviteToConversation(inviteData);
                    }
                    this.groupChat.participants = {
                        ...this.groupChat.participants,
                        [member.id]: member,
                    };
                    this.memberSearchResult = this.memberSearchResult.filter(item => item.id !== member.id);
                    if (!this.memberSearchResult.length || this.groupParticipants.length === iamConstants.MAX_PARTICIPANTS) {
                        this.doneAddingParticipants();
                    }
                }
            },
            doneAddingParticipants() {
                this.memberSearchResult = null;
                this.memberSearchText = '';
                this.searchMemberActive = false;
            },
            removeParticipant(member) {
                if (!this.isNewGroup) {
                    const removeData = {
                        roomId: this.groupChat.id,
                        memberId: member.id,
                    };
                    this.removeFromConversation(removeData);
                }
                delete this.groupChat.participants[member.id];
                this.groupChat.participants = { ...this.groupChat.participants };
            },
            searchMember(searchText) {
                if (searchText && searchText.length < 3) {
                    this.memberSearchResult = null;
                }
                clearTimeout(this.timeoutForTypeAhead);
                this.timeoutForTypeAhead = setTimeout(() => {
                    if (searchText && searchText.length > 2) {
                        this.setMemberDirectorySearchText(searchText);
                        this.initiatePeopleSearch()
                            .then((resp) => {
                                if (resp && resp.data) {
                                    const filteredResult = [];
                                    const participantsIds = Object.keys(this.groupChat.participants || {});
                                    resp.data.forEach((item) => {
                                        if (!participantsIds.includes(item.id)) {
                                            filteredResult.push(item);
                                        }
                                    });
                                    this.memberSearchResult = [...filteredResult];
                                }
                            })
                            .catch(() => {
                                this.memberSearchResult = null;
                            });
                    }
                }, 200);
            },
            memberName(member) {
                let memberName = '';
                if ((member.preferredName || member.firstName) && member.lastName) {
                    memberName = `${member.preferredName || member.firstName} ${member.lastName}`;
                } else {
                    memberName = member.name || '';
                }
                return memberName;
            },
            memberChapter(member) {
                let chapter = '';
                if (member && member.chapters && member.chapters.length) {
                    const primaryChapter = member.chapters.find(item => item.isPrimary) || member.chapters[0];
                    chapter = primaryChapter.name;
                } else {
                    chapter = member.primaryChapterName;
                }
                return chapter;
            },
            authorOf(message) {
                if (!message || !message.author) return {};
                return this.conversation.participants[message.author] || {};
            },
            initDeleteConversation() {
                if (!isValidConversationId(this.conversation.id)) {
                    return;
                }
                this.showDeleteConversationDialog = true;
            },
            confirmDeleteConversation() {
                this.deleteConversation({ conversationId: this.conversation.id }).then(() => {
                    this.showDeleteConversationDialog = false;
                    if (this.onDeleted) this.onDeleted();
                });
            },
        },
    };
</script>

<style scoped lang="scss">
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';
    @import '../../../common/styles/_commonClasses.scss';

    .messenger-group {
        margin-right: -1px;
        background-color: $white;
        min-height: 400px;
        height: 100%;

        &__create-title {
            height: 51px;
            border: 1px solid $ypo-blue;
            border-top-right-radius: 4px;
            background-color: $ypo-blue;
            color: $white;
            font-size: 16px;
            font-weight: 600;
            line-height: 19px;

            @include breakpoint(xs) {
                font-size: 12px;
            }
        }

        &__edit-title {
            background-color: $white;
            border: 1px solid $ypo-tile-border;
            border-top-right-radius: 4px;
            margin-top: -1px;
            color: $ypo_blue;
            font-size: 16px;
            font-weight: 600;
            line-height: 19px;

            @include breakpoint(xs) {
                background-color: $ypo-open-blue-gray;
                border: 1px solid $ypo-open-blue-gray;
            }
        }

        &__menu-actions {
            justify-content: flex-end;

            @include breakpoint(xs) {
                padding-top: 7px !important;
            }
        }

        &__name {
            font-size: 25px;
            font-family: 'Noto Sans', sans-serif;

            @include breakpoint(md) {
                font-size: 16px;
            }

            @include breakpoint(xs) {
                font-size: 16px;
            }
        }

        &__message {

            &-btn {
                @include breakpoint(xs) {
                    display: none;
                }
            }

            &-label {
                font-size: 13px;
                font-weight: 600;
                font-family: Gentona, sans-serif;
                padding-left: 10px;

                @include breakpoint(md) {
                    font-size: 12px;
                }
            }
        }

        &__new-group {
            border-bottom: 1px solid $ypo-tile-border;

            @include breakpoint(xs) {
                padding-right: 0 !important;
            }
        }

        &__input-box {
            .v-text-field {
                padding-top: 0 !important;
            }
            @include breakpoint(xs) {
                font-size: 12px;
            }
        }

        &__participants {

            &-count {
                flex: 0 1 auto !important;
                padding-right: 10px;
                font-size: 45px;
                height: 50px;
                position: relative;
                top: -15px;
                color: $ypo-dark-background-gray;

                &--max {
                    color: $ypo-red;
                }
            }

            &-remaining {
                &--count {
                    color: $ypo-dark-background-gray;
                    font-size: 12px;
                    letter-spacing: 0.6px;
                }

                &--label {
                    color: $ypo-blue;
                    font-size: 14px;
                    font-weight: 600;
                    letter-spacing: 0.32px;
                }
            }

            &-add {

                margin: 0 !important;

                @include breakpoint(xs) {
                    padding: 0 !important;
                }

                &-icon {
                    @include breakpoint(xs) {
                        margin-left: 40px;
                    }
                }

                &-label {
                    padding-left: 10px;
                    font-size: 13px;
                    font-weight: 600;

                    @include breakpoint(md) {
                        font-size: 12px;
                    }

                    @include breakpoint(xs) {
                        display: none;
                    }
                }
            }
        }

        &__search {
            &-result {
                border: 1px solid $ypo-tile-border;
                background-color: $white;
                min-height: 40px;
                width: 350px;
                position: absolute;
                z-index: 2;

                @include breakpoint(xs) {
                    width: 250px;
                }

                &--list {
                    overflow: auto;
                    max-height: 350px;

                    @include breakpoint(md) {
                        max-height: 250px;
                    }

                    @include breakpoint(xs) {
                        max-height: 220px;
                    }
                }

                &--done {
                    background-color: $ypo-tile-border;
                    text-align: right;
                }
            }

            &-no-result {
                color: $ypo-blue;
                font-weight: 600;
                padding: 10px;
            }
        }

        .member-result {
            &__desc {
                &-name {
                    color: $ypo-cta;
                    font-weight: 600;
                    font-size: 14px;

                    @include breakpoint(xs) {
                        font-size: 12px;
                    }
                }
                &-chapter {
                    font-size: 12px;

                    @include breakpoint(xs) {
                        font-size: 10px;
                    }
                }
            }
        }

        &__active-participants {
            border-top: 1px solid $ypo-tile-border;
            height: 100%;
            min-height: 300px;
            overflow: auto;

            @include breakpoint(xs) {
                margin-right: 0;
            }
        }

        &__actions {
            padding: 0 20px 10px 0 !important;
            justify-content: flex-end;
        }

        &__chat {

            &-title {
                color: $ypo-blue;
                background: $ypo-open-blue-gray;
                font-size: 16px;
                min-height: 51px;

                @include breakpoint(xs) {
                    background-color: $ypo-cta;
                    font-size: 14px;
                }

                &--name {
                    font-weight: 600;
                    padding: 12px 0 10px 20px;
                    text-align: left;

                    @include breakpoint(xs) {
                        text-align: center;
                        padding: 15px;
                    }
                }
            }

            &-menu {
                &--mobile {
                    display: none;
                    @include breakpoint(xs) {
                        display: block;
                    }
                }

                &--desktop {
                    @include breakpoint(xs) {
                        display: none;
                    }
                }
            }
        }
    }
</style>

<style lang="scss">
    @import '../../../common/styles/_responsive.scss';

    .messenger-group {
        .v-text-field {
            padding-top: 5px !important;
        }

        &__participants-add {
            @include breakpoint(xs) {
                .v-btn--active:before, .v-btn:hover:before, .v-btn:focus:before {
                    background-color: transparent !important;
                }
            }
        }
    }
</style>

